export const cepConstants = {
  CEP_REQUEST: 'CEP_REQUEST',
  CEP_SUCCESS: 'CEP_SUCCESS',
  CEP_FAILURE: 'CEP_FAILURE',
};
